import { createAction } from './index'

export const actionTypes = {
  DO_SESSION_ACTIVITY: '@@session/activity'
}

export const doSessionActivity = () => createAction(actionTypes.DO_SESSION_ACTIVITY)
